import { useMemo } from 'react';

import { seasonService } from '../../../../services';
import { createApiSlice } from '../../utils/createApiSlice';

const createManagementZoneSlice = createApiSlice({
  reducerPath: ['newGrowths', 'managementZones', 'createManagementZone'],
  apiFunction: seasonService.createManagementZoneV2
});

const { actions, useApiSelectors } = createManagementZoneSlice;

export const createManagementZoneActions = actions;

export const useCreateManagementZoneSelectors = () => {
  const { inProgress, errorMessage, success, updatedAt, response } =
    useApiSelectors();

  return useMemo(
    () => ({
      inProgress,
      errorMessage,
      success,
      updatedAt,
      response
    }),
    [errorMessage, inProgress, success, updatedAt, response]
  );
};

export default createManagementZoneSlice;
